import React from 'react';
import CardView from '../../CardView';
//import SideMenuData from '../SideMenuData';
//import { Package, MessageSquare, ShoppingBag, Mail } from 'react-feather';

const Dashboard = () => {
  return (
    <div>
<CardView />
    </div>


  );
};

export default Dashboard;
